// utils/getAttachmentUrl.js
const getAttachmentUrl = (path) => {
  if (!path) return "";

  // Development (local backend)
  if (process.env.NODE_ENV === "development") {
    return `http://localhost:5000${path}`;
  }

  // Production (force /api prefix for Node to serve correctly)
  return `https://mantraserp.com/api${path}`;
};

export default getAttachmentUrl;
